import React from 'react';

/**
 * Footer Component
 */
const Footer = () => {
  return (
    <footer>
      <div className="container">
        <p>&copy; 2024 RocketVerse - Space Exploration Platform. All rights reserved.</p>
        <p style={{ marginTop: '10px', fontSize: '14px' }}>
          Explore the universe, one launch at a time 🚀
        </p>
      </div>
    </footer>
  );
};

export default Footer;
